module.exports = {
	"root": "findify-components--rating-facet",
	"item": "findify-components--rating-facet__item",
	"star": "findify-components--rating-facet__star",
	"unfilled": "findify-components--rating-facet__unfilled",
	"checkbox": "findify-components--rating-facet__checkbox",
	"range": "findify-components--rating-facet__range",
	"input-wrap": "findify-components--rating-facet__input-wrap",
	"inputWrap": "findify-components--rating-facet__input-wrap",
	"input": "findify-components--rating-facet__input",
	"currency": "findify-components--rating-facet__currency",
	"submit": "findify-components--rating-facet__submit",
	"divider": "findify-components--rating-facet__divider"
};